import IconLabelledItem from '../IconLabelledItem/IconLabelledItem';

interface TriggerTemplateRuleProps {
  rule: string;
}

const TriggerTemplateRule = ({ rule }: TriggerTemplateRuleProps) => {
  const Content = {
    speed: (
      <>
        <IconLabelledItem iconName='zap' label='Excesso de velocidade de veículo' />
        <IconLabelledItem iconName='hourglass' label='A partir de 1 minuto' />
      </>
    ),
    road: (
      <>
        <IconLabelledItem iconName='gauge' label='Excesso de velocidade de via' />
        <IconLabelledItem iconName='hourglass' label='A partir de 1 minuto' />
        <IconLabelledItem iconName='circle' label='Gravíssima' iconColor='text-danger-dark' />
      </>
    ),
    idle: (
      <>
        <IconLabelledItem iconName='circle' label='Motor ocioso' />
        <IconLabelledItem iconName='hourglass' label='A partir de 3 minutos' />
      </>
    ),
  }[rule];

  return <div className='flex w-4/5 flex-1 gap-6'>{Content}</div>;
};

export default TriggerTemplateRule;
